import { pageSelectorGenerator } from '@test/pageSelectors';

export const CancelGiftConfirmationSelectors = pageSelectorGenerator('CancelGiftConfirmation', ['ContainerElement', 'DoneButton']);
